import 'css-chunksrc/client/scenes/assignToTask/tasksSelection/styles.scss';export default {
  "root": "_root_13978_1",
  "list": "_list_13978_6",
  "tasksSelection": "_tasksSelection_13978_20",
  "search": "_search_13978_26"
};